import { Button } from '@design-system/button';
import { Icon } from '@design-system/icon';
import { Modal } from '@design-system/modal';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import React, { FC } from 'react';

import { NotificationModalProps } from './models';

const NotificationModal: FC<NotificationModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  addToCartModal: {
    closeModalAriaLabel,
    errorMessageIcon,
    successMessageIcon,
    errorMessageLabel,
    successMessageLabel,
    productImage,
    headingUI,
    productName,
    productSize,
    packSizeLabel,
    packSizeValueUI,
    scentLabel,
    scentValueUI,
    productScent,
    quantityLabel,
    quantityValueUI,
    priceLabel,
    priceValueUI,
    itemsInCartLabel,
    itemsInCartValueUI,
    itemsInCart,
    totalCartLabel,
    totalCartValueUI,
    totalPrice,
    continueShopping,
    checkout,
    handleCheckoutNavigation,
  },
  quantityValue,
  currentPrice,
  hasAddToCartError,
  handleCloseModal,
}) => (
  <Modal
    isShowing={isModalOpen}
    close={handleCloseModal}
    closeModal={handleCloseModal}
    closeIconSize="large"
    closeAriaLabel={closeModalAriaLabel}
    className="shopify-block"
    topElements={
      <div
        className={classNames('shopify-block__modal-top-elements', {
          'shopify-block__modal-top-elements--with-error': hasAddToCartError,
        })}
      >
        <Icon
          {...(hasAddToCartError ? errorMessageIcon : successMessageIcon)}
          size={hasAddToCartError ? 24 : 16}
        />
        <Typography
          {...(hasAddToCartError ? errorMessageLabel : successMessageLabel)}
        />
      </div>
    }
  >
    {!hasAddToCartError ? (
      <>
        <hr />
        <div className="shopify-block__modal-content">
          <div className="shopify-block__modal-image">{productImage}</div>
          <div className="shopify-block__modal-product-info">
            <Typography {...headingUI} content={productName} />
            {productSize ? (
              <div className="shopify-block__modal-pack-size">
                <Typography {...packSizeLabel} />
                <Typography {...packSizeValueUI} content={productSize} />
              </div>
            ) : null}
            {scentLabel && productScent ? (
              <div className="shopify-block__modal-scent">
                <Typography {...scentLabel} />
                <Typography {...scentValueUI} content={productScent} />
              </div>
            ) : null}
          </div>
          <div className="shopify-block__modal-quantity">
            <Typography {...quantityLabel} />
            <Typography
              {...quantityValueUI}
              content={quantityValue.toString()}
            />
          </div>
          <div className="shopify-block__modal-price">
            <Typography {...priceLabel} />
            <Typography {...priceValueUI} content={currentPrice} />
          </div>
        </div>
        <div className="shopify-block__modal-total">
          <div className="shopify-block__modal-items-cart">
            <Typography {...itemsInCartLabel} />
            <Typography
              {...itemsInCartValueUI}
              content={itemsInCart.toString()}
            />
          </div>
          <div className="shopify-block__modal-total-cart">
            <Typography {...totalCartLabel} />
            <Typography {...totalCartValueUI} content={totalPrice} />
          </div>
        </div>
        <div className="shopify-block__modal-actions">
          <Button {...continueShopping} onClick={() => setIsModalOpen(false)} />
          <Button {...checkout} onClick={handleCheckoutNavigation} />
        </div>
      </>
    ) : null}
  </Modal>
);

export default NotificationModal;
